import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import TargetGroupDetail from '@app/views/ProjectTargetGroup/Detail';
import { memo } from 'react';

export default memo(
  withIfUser(TargetGroupDetail)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
